<template>
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M536.924-480.615 342.77-675.154l32.615-32.614 226.768 227.153-226.768 226.768-32.615-32.615 194.154-194.153Z"/></svg>
</template>
